import type { DirectiveBinding, VNode } from "vue";

import { useUserPermissionStore } from "@/stores/user-permission-store";

import type { UserPermissionName } from "@/machines/auth-machine";

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    const userPermissionModule = useUserPermissionStore();

    // Change the argument into an RS Docs permission and check it is true
    if (binding.arg && binding.arg.length > 0) {
      const permission = `can${binding.arg.replace(/^[a-z]/, binding.arg[0].toUpperCase())}` as UserPermissionName;

      if (userPermissionModule.userPermission?.[permission] === true) {
        return;
      }
    }

    // Hide the element by removing it from the DOM
    (vnode.el?.parentElement as HTMLElement | null)?.removeChild(vnode.el as Node);
  },
};
